import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to InnovateAI",
    title: "Unlock AI Insights for Your Business",
    content: "Leverage artificial intelligence to transform your data into actionable insights.",
    buttonText: "Discover More",
    buttonLink: "About-us",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to InnovateAI",
    title: "Empower Scalable AI Solutions",
    content: "Achieve efficiency and growth with cutting-edge AI solutions.",
    buttonText: "Discover More",
    buttonLink: "About-us",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to InnovateAI",
    title: "Seamless AI Integration Made Simple",
    content: "Integrate advanced AI tools into your platforms without disruption.",
    buttonText: "Discover More",
    buttonLink: "About-us",
  },
];

export default home;